module.exports = __webpack_public_path__ + "static/img/logo10.c488727.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/link2/logo10.jpg
// module id = jh6O
// module chunks = 1